module.exports = __webpack_public_path__ + "img/Group 487t3.63d2002e.svg";